module.exports = __webpack_public_path__ + "img/20191107163106410.7d56f0fc.jpg";